import SearchableMenu from 'components/SearchableMenu';

const WizardMenu = ({ menu, level, anchorEl }) => {
  const menuWidth = menu.width || 20;
  const leftPosition = `${(menuWidth + 0.4) * level}rem`;

  return (
    <SearchableMenu
      width={`${menuWidth}rem`}
      anchorEl={anchorEl}
      handleMenusClose={menu.onClose}
      isSearchable={menu.isSearchable}
      onSearch={menu.onSearch}
      isLoading={menu.isLoading}
      header={menu.header}
      subheader={menu.subheader}
      menuItems={menu.items}
      isMultiple={menu.isMultiple}
      actions={menu.actions || []}
      leftPosition={leftPosition}
      selectAllEnabled={menu.selectAllEnabled}
      toggleSelectAll={menu.toggleSelectAll}
    />
  );
};

export default WizardMenu;
